import {action} from "mobx";
import metabaseReportService from "../services/metabaseReportService";
import appStore from "./appStore";

class metabaseReportStore {
    @action getEmbedToken = async params => {
        const resultOfRequest = await metabaseReportService.getEmbedToken(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }

        return resultOfRequest.data;
    };
}

export default new metabaseReportStore();
